import React from "react";

import { PaperProps } from "@material-ui/core";

import MenuItem from "api/types/MenuItem";
import DesktopContainerDrawer from "containers/DesktopContainerDrawer";

import MobileContainerDrawer from "containers/MobileContainerDrawer";

import MenuItemCardDesktop from "./MenuItemCardDesktop";
import MenuItemCardMobile from "./MenuItemCardMobile";

interface Props extends PaperProps {
	item: MenuItem;
}

const MenuItemCard = (props: Props) => {
	return (
		<>
			<DesktopContainerDrawer>
				<MenuItemCardDesktop {...props} />
			</DesktopContainerDrawer>
			<MobileContainerDrawer>
				<MenuItemCardMobile {...props} />
			</MobileContainerDrawer>
		</>
	);
};

export default MenuItemCard;
